import ReviewCard from './ReviewCard';

// type
export type { CardVariantType } from './types';

export default ReviewCard;
